import React, { useState, useRef } from 'react';
import "./contact.scss";
import { Container, Row, Col, Form, Button} from "react-bootstrap";
import GlitchLines from '../../components/glitchLines/glitchLines';
import emailjs from '@emailjs/browser';
import { useAnimationContext } from '../../AnimationContext';

const Contact = () => { 
    const { isPreloaderComplete } = useAnimationContext();

    const parentRef = useRef(null);

    //for form validation
    const [validated, setValidated] = useState(false);

    // State to store the message
    const [message, setMessage] = useState('');
    const contactForm = useRef();

    const handleSubmit = (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
        event.stopPropagation();
        setValidated(true);
        } else {
            emailjs.sendForm(
                process.env.REACT_APP_SERVICE_ID, 
                process.env.REACT_APP_TEMPLATE_ID,
                contactForm.current, 
                process.env.REACT_APP_PUBLIC_KEY
            )
            .then((result) => {
                setMessage(<p>Your message has been submitted successfully. <br />
                    I will get back to you soon. Thank you for reaching out.</p>);
                setTimeout(() => setMessage(''), 10000);
                contactForm.current.reset();
                setValidated(false);
            }, (error) => {
                setMessage('There was an error submitting your message: ' + error.text);
                setValidated(true);
            });
        }
    };

    return (
        <div ref={parentRef}>
        <GlitchLines parentRef={parentRef} />
        <svg className="glitchLines">
            <defs>
                <filter id="noise">
                    <feTurbulence type="fractalNoise" baseFrequency="0.05" numOctaves="2" result="noise" seed="1" />
                    <feDisplacementMap in="SourceGraphic" in2="noise" scale="5" />
                </filter>
            </defs>
            <g className="d-none d-lg-block">
            <line x1="33%" y1="0" x2="100%" y2="70%" />
            <line x1="65%" y1="100%" x2="93%" y2="0" />
            </g>
            <g className="d-lg-none">
            <line x1="0" y1="20%" x2="85%" y2="0" />
            <line x1="0" y1="55%" x2="100%" y2="80%" />
            <line x1="0" y1="93%" x2="100%" y2="23%" />
            </g>
        </svg>
        <section id="secContact">
            <Container fluid className="d-lg-flex flex-column justify-content-lg-center" style={{ minHeight: 'calc(90vh - 380px)' }}>
                <Row>
                    <Col md={7}>
                        <div className="d-flex justify-content-center">
                            <h1 className={`headerText ${isPreloaderComplete ? 'headerTextHighlight' : ''}`}>Contact Me</h1>
                        </div>
                        <Form noValidate validated={validated} ref={contactForm} onSubmit={handleSubmit}>
                            <Form.Group className="mb-3" controlId="name">
                                <Form.Label>Name</Form.Label>
                                <Form.Control required type="text" placeholder="John Smith" name="user_name" />
                                <Form.Control.Feedback type="invalid">
                                    Please state your name.
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="email">
                                <Form.Label>Email Address</Form.Label>
                                <Form.Control required type="email" placeholder="johnsmith@email.com" name="user_email"/>
                                <Form.Control.Feedback type="invalid">
                                    Please provide a valid email address.
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mb-5" controlId="message">
                                <Form.Label>Message</Form.Label>
                                <Form.Control className='dont hover-this' as="textarea" rows={3} required placeholder="Your message here" name="message" />
                                <Form.Control.Feedback type="invalid">
                                    Please write your message.
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="text-end">
                            <Button variant="primary" type="submit" className='hover-this'>
                                Submit
                            </Button>
                            </Form.Group>
                        </Form>
                        {message && <div className="submitMessage">{message}</div>}
                    </Col>
                    <Col xs={12} md={5} className="d-flex justify-content-start align-items-center justify-content-md-center" id="contactInfoCol">
                        <div id="contactInfoBack" className="contactInfodiv"></div>
                        <div id="contactInfoFront" className="contactInfodiv">
                            <div className="d-flex flex-column justify-content-center align-items-center contactInfo" style={{ transform: 'rotate(-8deg)' }}>
                                <Button variant="primary" type="button" onClick={() => window.location = 'mailto:veliamani@gmail.com'}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16" className="bi bi-envelope-fill svg_black">
                                        <path className="svgB" d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757Zm3.436-.586L16 11.801V4.697l-5.803 3.546Z"></path>
                                    </svg>
                                    CLICK HERE TO SEND EMAIL
                                </Button>
                                <div className="d-inline-flex">
                                    <h5 className="contactItem1">Mobile (Kenya):</h5>
                                    <h5>+254 703 928923</h5>
                                </div>
                                <div className="d-flex">
                                    <h5 className="contactItem1">Mobile (Tanzania):</h5>
                                    <h5>+255 769 740989</h5>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
        </div>
    )
}

export default Contact;